import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import moment from "moment";
import Swal from "sweetalert2";

const AssignWOModal = ({
    currentWO,
    dailyPlanData,
    handleWOEdit,
    handleWORemove,
    machine_id,
}) => {
    const [dailyPlanInfo, setDailyPlanInfo] = useState(null);
    const {
        handleSubmit,
        register,
        reset,
        formState: { isValid, errors },
        trigger,
        watch,
    } = useForm({ mode: "onBlur" });

    // const reason = watch("reason");

    const onSubmit = (data) => {
        const date = new Date(data.wodate);
        date.setHours(0, 0, 0, 0);
        // const formattedDate = date.toString();
        const formattedDate = date;

        handleWOEdit(
            new Date(formattedDate),
            Number(data.woquantity / (currentWO?.mould_size ?? 1))
            // data.reason
        );
    };

    const handleRemoveDailyPlan = () => {
        // if (!reason || reason.trim() === "") {
        //     Swal.fire({
        //         title: "Error",
        //         text: "Reason is required to remove the daily plan.",
        //         icon: "warning",
        //     });
        //     return;
        // }
        Swal.fire({
            text: "Are you sure? You will not be able to recover this data!",
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No, cancel!`,
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(reason);
                handleWORemove();
            }
        });
    };

    useEffect(() => {
        if (currentWO) {
            setDailyPlanInfo(
                dailyPlanData?.data?.filter(
                    (data) => data?.id === currentWO?.bo
                )?.[0]
            );
            const formattedDate = moment(currentWO.start).format("YYYY-MM-DD");
            reset({
                wodate: formattedDate,
                woquantity: currentWO.amount * (currentWO?.mould_size ?? 1),
            });
        }
    }, [currentWO, reset, dailyPlanData]);

    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);

    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id={`edit-wo-modal-${machine_id}`}
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <button className="close" data-bs-dismiss="modal">
                        <em
                            className="icon ni ni-cross"
                            aria-hidden="true"
                        ></em>
                    </button>
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Edit Daily Plan - {currentWO?.daily_plan_code}
                        </h5>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 mb-2">
                                    <p>
                                        <strong>Item</strong>:{" "}
                                        {dailyPlanInfo?.item?.item_name}
                                    </p>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <p>
                                        <strong>Work order</strong>:{" "}
                                        {
                                            dailyPlanInfo?.work_order
                                                ?.work_order_code
                                        }
                                    </p>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <p>
                                        <strong>Per Cycle Output</strong>:{" "}
                                        {currentWO?.mould_size}
                                    </p>
                                </div>
                                <div className="col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="wo">
                                            Production
                                            <span className="fs-8 text-danger ms-1">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            {...register("woquantity", {
                                                required:
                                                    "Production quantity is required",
                                                min: {
                                                    value: 1,
                                                    message:
                                                        "Production quantity must be at least 1",
                                                },
                                                // max: {
                                                //     value:
                                                //         currentWO?.amount *
                                                //         (currentWO?.mould_size ??
                                                //             1),
                                                //     message: `Production quantity cannot exceed ${
                                                //         currentWO?.amount *
                                                //         (currentWO?.mould_size ??
                                                //             1)
                                                //     }`,
                                                // },
                                            })}
                                            onBlur={() => trigger()}
                                        />
                                        {errors.woquantity && (
                                            <span className="fs-8 text-danger">
                                                {errors.woquantity?.message}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="wo">
                                            Planned Date
                                            <span className="fs-8 text-danger ms-1">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register("wodate", {
                                                required:
                                                    "Planned date is required",
                                            })}
                                        />
                                        {errors.wodate && (
                                            <span className="fs-8 text-danger">
                                                {errors.wodate?.message}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                {/* <div className="col-sm-12 mt-2">
                                    <label className="form-label">
                                        Reason
                                        <span className="fs-8 text-danger ms-1">
                                            *
                                        </span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Reason..."
                                        id="text-forms-reason"
                                        {...register("reason", {
                                            required: "Reason is required",
                                        })}
                                    ></textarea>
                                    {errors.reason && (
                                        <span className="text-danger">
                                            {errors.reason.message}
                                        </span>
                                    )}
                                </div> */}
                            </div>
                        </div>
                        <div className="modal-footer bg-light">
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-bs-dismiss={isValid ? "modal" : ""}
                                onClick={handleRemoveDailyPlan}
                                disabled={moment(currentWO?.start).isBefore(
                                    moment().subtract(1, "day")
                                )}
                            >
                                Remove
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                disabled={
                                    moment(currentWO?.start).isBefore(
                                        moment().subtract(1, "day")
                                    ) || !isValid
                                }
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AssignWOModal;
